import { render, staticRenderFns } from "./addAndEditData.vue?vue&type=template&id=50808e24&scoped=true&"
import script from "./addAndEditData.vue?vue&type=script&lang=js&"
export * from "./addAndEditData.vue?vue&type=script&lang=js&"
import style0 from "./addAndEditData.vue?vue&type=style&index=0&id=50808e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50808e24",
  null
  
)

export default component.exports